import type { IServiceJourney } from '../../../../models/service-journey.model';
import { LineApiModel } from './line.api-model';

export class ServiceJourneyApiModel {
  public static mapToBusinessModel(apiModel: ServiceJourneyApiModel): IServiceJourney {
    return {
      gid: apiModel.gid,
      line: LineApiModel.mapToBusinessModel(apiModel.line),
      direction: apiModel.direction,
      number: undefined,
      via: apiModel.via,
    };
  }

  public gid!: string;
  public direction!: string;
  public via?: string;
  public line!: LineApiModel;
}
